import React from 'react';
import WordImg from '../Assets/WordImg.svg'
import DefaultImg from '../Assets/DefaultImg.svg'
import ExcelImg from '../Assets/ExcelImg.svg'
import PdfImg from '../Assets/PdfImg.svg'
import ImageImg from '../Assets/ImageImg.svg'



export const GetFileIcon = (filename: string/*, props?: Partial<CustomIconComponentProps>*/) => {
    const pieces = filename.split(/[\s.]+/);
    const extension = pieces[pieces.length - 1].toLowerCase();

    switch (extension) {
        case "pdf":
            return (<img src={PdfImg} style={{ height: 24 }} />);
        case "doc":
        case "docx":
            return (<img src={WordImg} style={{ height: 24 }}/>);
        case "xls":
        case "xlsx":
        case "csv":
            return (<img src={ExcelImg} style={{ height: 24 }}/>);
        case "ppt":
        case "pptx":
            return (<img src={DefaultImg} style={{ height: 24 }}/>);
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
        case "pneg":
            return (<img src={ImageImg} style={{ height: 24 }}/>);
        case ".mp4":
        case ".avi":
        case ".mov":
        case ".wma":
        case ".wmv":
            return (<img src={ImageImg} style={{ height: 24 }}/>);
        case "txt":
        case "rtf":
            return (<img src={DefaultImg} style={{ height: 24 }}/>);
        default:
            return (<img src={DefaultImg} style={{ height: 24 }}/>);
    }
};
